import { Directive, ElementRef, HostListener, input } from '@angular/core';

@Directive({
  selector: '[appInputPattern]',
  standalone: true,
})
export class InputPatternDirective {
  appInputPattern = input.required<string | RegExp>();
  pastePattern = input.required<RegExp>();
  anyPattern = '/./';

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.appInputPattern()).test(event.key);
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    // if any value  - don't check
    if (String(this.pastePattern()) !== this.anyPattern) {
      this.validateField(event);
    }
  }

  validateField(event: ClipboardEvent) {
    event.preventDefault();
    const value = String(event.clipboardData?.getData('text/plain'));
    const newValue = value.replace(this.pastePattern(), '');
    document.execCommand('insertHTML', false, newValue);
  }

}
